"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_STICKY_HIDDEN = exports.CLASS_STICKY = exports.CLASS_OPEN = exports.DATA_CONTACT_BUTTONS_ACTIONS = exports.DATA_CONTACT_BUTTONS_WRAPPER = exports.DATA_HEADER_MENU_DROPDOWN = exports.DATA_HEADER_MENU_DROPDOWN_WRAPPER = exports.DATA_HEADER_MENU_DESKTOP_CLOSE = exports.DATA_HEADER_MENU_DESKTOP_LINK = exports.DATA_HEADER_MENU_MOBILE_LINK_BACK = exports.DATA_HEADER_MENU_MOBILE_LINK = exports.DATA_HEADER_MENU_MOBILE = exports.DATA_HEADER_MENU_BTN = void 0;
exports.DATA_HEADER_MENU_BTN = 'data-header-menu-btn';
exports.DATA_HEADER_MENU_MOBILE = 'data-header-menu-mobile';
exports.DATA_HEADER_MENU_MOBILE_LINK = 'data-header-menu-mobile-link';
exports.DATA_HEADER_MENU_MOBILE_LINK_BACK = 'data-header-menu-mobile-link-back';
exports.DATA_HEADER_MENU_DESKTOP_LINK = 'data-header-menu-desktop-link';
exports.DATA_HEADER_MENU_DESKTOP_CLOSE = 'data-header-menu-desktop-close';
exports.DATA_HEADER_MENU_DROPDOWN_WRAPPER = 'data-header-menu-dropdown-wrapper';
exports.DATA_HEADER_MENU_DROPDOWN = 'data-header-menu-dropdown';
exports.DATA_CONTACT_BUTTONS_WRAPPER = 'data-contact-buttons-wrapper';
exports.DATA_CONTACT_BUTTONS_ACTIONS = 'data-contact-buttons-actions';
exports.CLASS_OPEN = 'is-open';
exports.CLASS_STICKY = 'is-sticky';
exports.CLASS_STICKY_HIDDEN = 'is-sticky-hidden';
